<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            :ajax-params="ajaxParams"
            :refresh.sync="refreshTable"
            :loading="tableIsLoading"
            ajax-path="nable/customers"
            @rowSelected="handleRowSelected"     
        />
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableIsLoading: false,
                refreshTable: false,
                ajaxParams:{},
                columns: [
                    {
                        title: 'Name',
                        field: 'customername',
                        sorter: 'string',
                        minWidth: 250,
                    },
                    {
                        title: 'Contact Name',
                        field: 'contactfirstname',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.row.data.contactfirstname) {
                                return `${_cell.row.data.contactfirstname} ${_cell.row.data.contactlastname}`;
                            }

                            return '--';
                        }
                    },
                    {
                        title: 'Contact Email',
                        field: 'contactemail',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return '--';
                        }
                    },                    
                ],
                actions: [],
            }
        },
        methods: {
            handleRowSelected(selected) {

            }
        }
    }
</script>